export class LegendItemModel {
  constructor(public name: string,
              public description: string) {
  }
}
